export default __webpack_public_path__ + "static/media/IMG_5580.25f3e6b1.jpg";